import { useEffect } from "react";

const useAlphabeticInput = () => {
  useEffect(() => {
    const handleInput = (e) => {
      const input = e.target;
      if (!input.classList.contains("only-alphabets")) return;

      // Allow alphabets and space only
      let value = input.value.replace(/[^a-zA-Z\s]/g, ""); 

      const maxLength = input.getAttribute("data-maxlength");
      if (maxLength) {
        value = value.slice(0, parseInt(maxLength));
      }

      input.value = value;
    };

    document.addEventListener("input", handleInput);
    return () => document.removeEventListener("input", handleInput);
  }, []);
};

export default useAlphabeticInput;